const STATUS_LABELS = {
  new: "Nouvelle", available: "Disponible", interested: "Intéressé", assigned: "Assigné",
  er: "En route", sp: "Sur place", pec: "PEC", dep: "Terminée",
  completed: "Terminée", cancelled: "Annulée", rejected: "Refusée", archived: "Archivée",
};

export default function StatusBadge({ status }) {
  // Defensive: if `status` is missing/null/undefined, render nothing
  // rather than emitting an empty pill that would still claim layout
  // and produce a broken `status-undefined` CSS class. This is one of
  // the symptoms behind the "page noire" report on the driver app.
  if (status === null || status === undefined || status === "") return null;
  const safe = String(status);
  return (
    <span data-testid={`status-badge-${safe}`}
      className={`status-${safe} inline-flex items-center px-2.5 py-1 rounded text-xs font-semibold border tracking-wide uppercase`}>
      {STATUS_LABELS[safe] || safe}
    </span>
  );
}
